<div>
  <form [formGroup]="form" class="my-1">
    <div>
      <div class="field grid">
        <div class="col-3 p-offset-3 column-label text-center"><strong>Sku Description</strong></div>
        <div class="col-3 column-label text-center"><strong>HsCode</strong></div>
      </div>
    </div>
    <div formArrayName="dhlInvoiceUpdateHsCodeBeanList" class="mt-3">
      <div *ngFor="let option of skuDescriptionOptions; index as i" class="field grid" [formGroupName]="i">
        <div class="col-3 p-offset-3 column-label">
          <div><input type="text" pInputText formControlName="modifiedSkuDescription" [(ngModel)]="option.modifiedSkuDescription"/></div>
        </div>
        <div class="col-3 column-label">
          <input type="text" pInputText formControlName="modifiedHsCode" [(ngModel)]="option.modifiedHsCode" />
        </div>
      </div>
    </div>
    <div class="grid mt-2">
        <div class="col text-center">
          <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}"
            (click)="confirmBtnClick($event)"></button>
        </div>
    </div>
  </form>
</div>
